<div class="container">

  <div class="head">
    <div mat-dialog-title
         class="head-label">
      {{ (isUpdate ? 'MENU.MENUS.EDIT' : 'MENU.MENUS.CREATE') | translate }}
    </div>
    <mat-icon mat-dialog-close class="head-exit">close</mat-icon>
  </div>

  <form [formGroup]="form" class="form" (ngSubmit)="submit()">
    <div class="form-fields">
      <mat-form-field class="form-field">
        <mat-label>{{ 'MENU.SECTIONS.NAME' | translate }}</mat-label>
        <input matInput type="text"
               [formControl]="getControl('name')"
               [placeholder]="'MENU.SECTIONS.NAME' | translate"/>
        <mat-error *ngIf="getControl('name').errors?.required">
          {{ 'ERRORS.REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ 'MENU.SECTIONS.DESCRIPTION' | translate }}</mat-label>
        <input matInput type="text"
               [formControl]="getControl('description')"
               [placeholder]="'MENU.SECTIONS.DESCRIPTION' | translate"/>
        <mat-error *ngIf="getControl('description').errors?.required">
          {{ 'ERRORS.REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div *ngIf="!downloadProcess" class="form-bottom">
      <button
        class="submit"
        mat-button
        [disabled]="form.invalid"
      >{{ 'MENU.SAVE' | translate }}
      </button>
    </div>
    <mat-progress-spinner
      *ngIf="downloadProcess"
      mode="indeterminate"
      [diameter]="30">
    </mat-progress-spinner>

  </form>


</div>
